import { Moment, QuickTip } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { Stack } from '@mui/material'

import { InfoRow } from '#/components/FormatCell/Types/Infos'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

type DiscardProps = {
  death_method_text: string
  reason_text: string
  timestamp: string
  creator: string
  comment?: string
}

const TypeDiscard = ({ value }: { value: DiscardProps }) => {
  const { comment, creator, death_method_text, reason_text, timestamp } = value ?? {}

  if (!reason_text) {
    return <span>-</span>
  }

  const items = [
    {
      label: Translate({ messageKey: 'death_method' }),
      value: death_method_text,
    },
    {
      label: Translate({ messageKey: 'reason_text' }),
      value: reason_text,
    },
    {
      label: Translate({ messageKey: 'comment' }),
      value: comment,
    },
    {
      label: Translate({ messageKey: 'date' }),
      value: Moment.view(timestamp),
    },
    {
      label: Translate({ messageKey: 'created_by' }),
      value: creator,
    },
  ].filter(({ value }) => value)

  return (
    <div style={{ display: 'flex' }}>
      <QuickTip
        title={Translate({
          messageKey: 'discarded_or_deleted',
          params: { item: Translate({ lower: true, messageKey: 'animal' }) },
        })}
        icon={<Icon size="large" name="discard" />}
        description={
          <Stack spacing={0.5} sx={{ fontSize: 'smaller', mt: 1.5 }}>
            {items?.map(({ label, value }) => (
              <InfoRow label={label as string} component={'span'} key={label}>
                {value}
              </InfoRow>
            ))}
          </Stack>
        }
        slotProps={{
          icon: {
            ...Colors.feedback.error,
            borderRadius: '20px',
            padding: '2px',
          },
          paper: {
            backgroundColor: '#fff',
            gap: 0,
          },
          title: {
            color: theme => theme.palette.error.main,
          },
        }}
      />
    </div>
  )
}

export { TypeDiscard }
